import { z } from 'zod';

export const ImageModel = z.object({
  id: z.string(),
  altText: z.string().default(''),
  source: z.string(),
});
